import { render, staticRenderFns } from "./NewRealEstateEdit.vue?vue&type=template&id=99f1f3b2&scoped=true&"
import script from "./NewRealEstateEdit.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateEdit.vue?vue&type=style&index=0&id=99f1f3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f1f3b2",
  null
  
)

export default component.exports